import React from 'react';
import InfoPage, { Section } from '../../components/InfoPage';
import { Mail, MessageCircle, Clock } from 'lucide-react';

const ContactInfo = () => (
  <InfoPage
    title="Contact information"
    subtitle="Real humans, fast replies. Pick the channel that works for you."
  >
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div className="p-5 rounded-2xl flex items-start gap-3" style={{ backgroundColor: '#F5EDE0' }}>
        <Mail size={22} color="#2D5A3D" />
        <div>
          <p className="font-semibold text-[15px]" style={{ color: '#2C2418' }}>Email</p>
          <p className="text-[13px] opacity-85" style={{ color: '#2C2418' }}>hello@k-root.example</p>
          <p className="text-[13px] opacity-85" style={{ color: '#2C2418' }}>support@k-root.example</p>
        </div>
      </div>
      <div className="p-5 rounded-2xl flex items-start gap-3" style={{ backgroundColor: '#F5EDE0' }}>
        <Clock size={22} color="#2D5A3D" />
        <div>
          <p className="font-semibold text-[15px]" style={{ color: '#2C2418' }}>Hours</p>
          <p className="text-[13px] opacity-85" style={{ color: '#2C2418' }}>Mon–Fri · 9am to 6pm EST</p>
          <p className="text-[13px] opacity-85" style={{ color: '#2C2418' }}>Reply within 24 business hours</p>
        </div>
      </div>
      <div className="p-5 rounded-2xl flex items-start gap-3 sm:col-span-2" style={{ backgroundColor: '#F5EDE0' }}>
        <MessageCircle size={22} color="#2D5A3D" />
        <div>
          <p className="font-semibold text-[15px]" style={{ color: '#2C2418' }}>Order questions</p>
          <p className="text-[13px] opacity-85" style={{ color: '#2C2418' }}>
            Have your order number ready (it starts with <em>#YORA-</em>) so we can pull it up in seconds.
          </p>
        </div>
      </div>
    </div>

    <Section heading="Business inquiries">
      <p>
        Wholesale, press, and partnerships: <span className="underline">partnerships@k-root.example</span>.
      </p>
    </Section>

    <Section heading="Mailing address">
      <p>
        K-Root · 1234 Bloom Avenue, Suite 200 · Wilmington, DE 19801 · USA
      </p>
    </Section>
  </InfoPage>
);

export default ContactInfo;
